class DeliveryTime extends HTMLElement {
    constructor() {
        super();

        this.formatString = this.getAttribute("data-frm-day");
        this.excludedDays = this.getAttribute("data-exclude-day").replace(/ /g, '').split(",");
        this.numbDateStart = parseInt(this.getAttribute("data-estimate-start"));
        this.numbDateEnd = parseInt(this.getAttribute("data-estimate-end"));
        this.processingTime = parseInt(this.getAttribute("data-processing-time")) || 1;
        this.targetTime = this.getAttribute("data-time");

        // hour optional (für Produktseite UND Warenkorb)
        this.hr = this.querySelector('.productView-dlvr__remaining-hr');
        this.mins = this.querySelector('.productView-dlvr__remaining-mins');
        this.countdownEnabled = (this.hr && this.mins);

        const now = new Date();
        const orderDay = now.getDay();
        const orderHour = now.getHours();
        const orderMinute = now.getMinutes();

        // Freitag-Regel (Bestandslogik beibehalten)
        if (orderDay === 5) {
            if (orderHour < 16 || (orderHour === 16 && orderMinute <= 30)) {
                this.processingTime = 1;
            } else {
                this.processingTime = 2;
            }
        } else if (orderDay === 6 || orderDay === 0) {
            // Samstag / Sonntag → +1 Tag Bearbeitung
            this.processingTime += 1;
        }

        this.checkExclude = this.checkAllExcludeDays(this.excludedDays);
        if (this.checkExclude) return;

        this.productDeliveryTime();

        // Countdown nur, wenn Elemente vorhanden sind (Produktseite, nicht Cart)
        if (this.countdownEnabled) {
            const countdown = this.countdownToTime();
            this.hr.innerHTML = countdown.hours;
            this.mins.innerHTML = countdown.minutes;

            setInterval(() => {
                const countdown = this.countdownToTime();
                this.hr.innerHTML = countdown.hours;
                this.mins.innerHTML = countdown.minutes;
            }, 1000);
        }

        this.style.display = "block";
    }

    // HOLIDAYS TO 2030
    holidayList = [
        // 2024
        "2024-01-01","2024-03-29","2024-04-01","2024-05-01","2024-05-09","2024-05-20",
        "2024-10-03","2024-10-31","2024-12-25","2024-12-26",

        // 2025
        "2025-01-01","2025-04-18","2025-04-21","2025-05-01","2025-05-29","2025-06-09",
        "2025-10-03","2025-10-31","2025-12-25","2025-12-26",

        // 2026
        "2026-01-01","2026-04-03","2026-04-06","2026-05-01","2026-05-14","2026-05-25",
        "2026-10-03","2026-10-31","2026-12-25","2026-12-26",

        // 2027
        "2027-01-01","2027-03-26","2027-03-29","2027-05-01","2027-05-06","2027-05-17",
        "2027-10-03","2027-10-31","2027-12-25","2027-12-26",

        // 2028
        "2028-01-01","2028-04-14","2028-04-17","2028-05-01","2028-05-25","2028-06-05",
        "2028-10-03","2028-10-31","2028-12-25","2028-12-26",

        // 2029
        "2029-01-01","2029-03-30","2029-04-02","2029-05-01","2029-05-10","2029-05-21",
        "2029-10-03","2029-10-31","2029-12-25","2029-12-26",

        // 2030
        "2030-01-01","2030-04-19","2030-04-22","2030-05-01","2030-05-30","2030-06-10",
        "2030-10-03","2030-10-31","2030-12-25","2030-12-26",
    ];

    checkAllExcludeDays(excludedDays) {
        const now = new Date();
        const deliveryDateTime = new Date(now);

        for (let day of excludedDays) {
            const dayIndex = ['SUN','MON','TUE','WED','THU','FRI','SAT'].indexOf(day);
            if (deliveryDateTime.getDay() === dayIndex) return true;
        }
        return false;
    }

    productDeliveryTime() {
        const $orderDlvr = $("[data-delivery-time]");
        if ($orderDlvr.length == 0) return;

        let startProcessingDay = this.calculateProcessingDate(this.processingTime);
        let startDay = this.calculateDeliveryDate(this.numbDateStart, startProcessingDay);
        let endDay = this.calculateDeliveryDate(this.numbDateEnd, startProcessingDay);

        const now = new Date();

        // Bestehende Freitag-Ende-Logik beibehalten
        if (now.getDay() === 5 && (now.getHours() < 16 || (now.getHours() === 16 && now.getMinutes() <= 30))) {
            endDay.setDate(endDay.getDate() + 1);
            while (this.isExcludedDay(endDay) || this.isHoliday(endDay)) {
                endDay.setDate(endDay.getDate() + 1);
            }
        }

        // NEU: Wenn Start- und Endtag identisch → Enddatum +1 Werktag
        if (this.isSameDay(startDay, endDay)) {
            endDay = this.calculateDeliveryDate(1, endDay);
        }

        const formattedStartDate = this.formatDate(startDay, this.formatString);
        const formattedEndDate = this.formatDate(endDay, this.formatString);

        $orderDlvr.find('[data-start-delivery]').html(formattedStartDate);
        $orderDlvr.find('[data-end-delivery]').html(formattedEndDate);

        if (window.latestDeliveryDate === undefined || endDay > window.latestDeliveryDate) {
            window.latestDeliveryDate = endDay;
        }
    }

    isSameDay(a, b) {
        return (
            a.getFullYear() === b.getFullYear() &&
            a.getMonth() === b.getMonth() &&
            a.getDate() === b.getDate()
        );
    }

    formatDate(date, formatString) {
        const dayOfWeek = date.toLocaleDateString('de-DE', { weekday: 'long' }),
              dayOfMonth = date.toLocaleDateString('de-DE', { day: '2-digit' }),
              month = date.toLocaleDateString('de-DE', { month: 'long' }),
              monthNumber = (date.getMonth() + 1).toString().padStart(2, '0'),
              year = date.toLocaleDateString('de-DE', { year: 'numeric' });

        return formatString
            .replace('d', dayOfWeek)
            .replace('DD', dayOfMonth)
            .replace('MMM', month)
            .replace('MM', monthNumber)
            .replace('YYYY', year);
    }

    calculateProcessingDate(days) {
        const now = new Date();
        let processingDate = new Date(now);

        while (days > 0) {
            processingDate.setDate(processingDate.getDate() + 1);
            if (!this.isExcludedDay(processingDate) && !this.isHoliday(processingDate)) {
                days--;
            }
        }
        return processingDate;
    }

    calculateDeliveryDate(days, startDate) {
        let deliveryDate = new Date(startDate);
        while (days > 0) {
            deliveryDate.setDate(deliveryDate.getDate() + 1);
            if (!this.isExcludedDay(deliveryDate) && !this.isHoliday(deliveryDate)) {
                days--;
            }
        }
        return deliveryDate;
    }

    isExcludedDay(date) {
        const dayIndex = date.getDay();
        return this.excludedDays.includes(['SUN','MON','TUE','WED','THU','FRI','SAT'][dayIndex]);
    }

    isHoliday(date) {
        const dateString = date.toISOString().split('T')[0];
        return this.holidayList.includes(dateString);
    }

    countdownToTime() {
        const currentTime = new Date();
        const orderDay = currentTime.getDay();
        let targetTimeString;

        if (orderDay === 5) {
            targetTimeString = `${currentTime.toDateString()} 16:30:00`;
        } else {
            targetTimeString = `${currentTime.toDateString()} 23:59:59`;
        }

        const targetDateTime = new Date(targetTimeString);
        if (targetDateTime < currentTime) targetDateTime.setDate(targetDateTime.getDate() + 1);

        const remainingTime = targetDateTime - currentTime;

        const hours = Math.floor(remainingTime / (1000 * 60 * 60)),
              minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));

        return { hours, minutes };
    }
}

customElements.define('delivery-time', DeliveryTime);
